import { Container } from "react-bootstrap";
import PreCertLinkBanner from "./Shared/Components/PreCertLinkBanner";

export default function UnauthorizedPage() {
    return (
        <header>
               <PreCertLinkBanner/>
            <Container>
                <div>
                    You are not authorized to access this page. If you have questions, please email us at <a  href={"mailTo:credentials@abpn.com?subject=ABPN Account Help"}>credentials@abpn.com</a>.
                </div>
            </Container>
        </header>
    );
}